import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[credit-debit-card]'
})
export class CreditDebitCardDirective {

@HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let trimmed = input.value.replace(/\s+/g, '');

    if (trimmed.length >= 16) {
      trimmed = trimmed.substr(0, 16);
    }

    let numbers = [];
    for (let i = 0; i < trimmed.length; i += 4) {
      numbers.push(trimmed.substr(i, 4));
    }
    input.value = numbers.join(' ');
  }
}

@Directive({
  selector: '[expiry-date]'
})
export class ExpiryDateDirective {

@HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    let trimmed = input.value.replace(/\//g, '');
    if (trimmed.length > 4) {
      trimmed = trimmed.substr(0, 4);
    }

    let numbers = [];
    for (let i = 0; i < trimmed.length; i += 2) {
      numbers.push(trimmed.substr(i, 2));
    }
    input.value = numbers.join('/');
  }
}


// WEBPACK FOOTER //
// ./src/directives/cardnumber/cardnumber.ts